import type { CreateBookingController } from '@carlito/hotel-apis';
import { ControllerBodyParameters, ControllerExecutionSuccessResult } from '@carlito/ddd';
import { bookitoRequest } from './api';

export type CreateBookingParams = ControllerBodyParameters<CreateBookingController>;
export type CreateBookingResponse = ControllerExecutionSuccessResult<CreateBookingController>;

export async function createBooking(params: CreateBookingParams) {
  return await bookitoRequest<CreateBookingController>('/booking', {
    body: JSON.stringify(params),
    method: 'POST',
  });
}
